import React from 'react';
import { MdPermIdentity } from 'react-icons/md';
import { FaCheckSquare } from 'react-icons/fa';
import { GrMoney } from 'react-icons/gr';
import { formatNumber } from '../util/Formater';


export default function DashBoard(props) {
   let { user, account } = props;
   return (
      <>
         <div className='level'>
            <div className='level-item has-text-centered'>
               <div>
                  <p className='heading'>
                     <MdPermIdentity />
                     {'   '}Agent
                  </p>
                  <p className='title is-4'>{account.vendorNames}</p>
               </div>
            </div>
            <div className='level-item has-text-centered'>
               <div>
                  <p className='heading'>
                     <GrMoney />
                     {'   '}Balance
                  </p>
                  <p className='title is-4'>{formatNumber(account.vendorAccountBalance)} FRW</p>
               </div>
            </div>

            <div className='level-item has-text-centered'>
               <div>
                  <p className='heading'>Today Sales</p>
                  <p className='title is-4'>{formatNumber(account.totalSalesAmount)}</p>
               </div>
            </div>
            <div className='level-item has-text-centered'>
               <div>
                  <p className='heading'>Today Transactions</p>
                  <p className='title is-4'>{account.totalSalesCount}</p>
               </div>
            </div>
            <div className='level-item has-text-centered'>
               <div>
                  <p className='heading'>
                     {<FaCheckSquare />}
                     {'  '}Status
                  </p>
                  <p className='title is-4'>
                     {'  '}
                     {user.vendorAccountStatus === 1 ? 'Active' : 'Inactive'}
                  </p>
               </div>
            </div>
         </div>
      </>
   );
}
